<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <b-form-group
            label="Nome/Razão Tomador"
            label-for="fsep_razao_social_tomador">
          <input
              id="fsep_razao_social_tomador"
              v-model="filtro.sep_razao_social_tomador"
              type="text"
              maxlength="20"
              class="form-control"
              placeholder=" ">
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
            class="font-weight-medium"
            label="CPF/CNPJ do Tomador">
          <the-mask class="form-control" v-model="filtro.sep_cpf_cnpj_tomador"
                    :mask="['###.###.###-##', '##.###.###/####-##']"/>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
            label="Ano"
            label-for="not_emissao_ano">
          <input
              id="not_emissao_ano"
              v-model="filtro.not_emissao_ano"
              v-mask="'####'"
              type="text"
              maxlength="4"
              class="form-control"
              placeholder="">
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <b-form-group label="Tributação" label-for="sep_exigibilidade_iss">
          <select id="sep_exigibilidade_iss"
                  v-model="filtro.sep_exigibilidade_iss"
                  class="custom-select" type="text">
            <option value="">Todos</option>
            <option value="1">Exigível</option>
            <option value="2">Não Incidência</option>
            <option value="3">Isenção</option>
            <option value="5">Imune</option>
          </select>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="Exigibilidade" label-for="sep_municipio_incidencia">
          <select id="sep_municipio_incidencia"
                  v-model="filtro.sep_municipio_incidencia"
                  class="custom-select" type="text">
            <option value="">Todos</option>
            <option v-bind:value="'='+entidade.mun_codigo">No Município</option>
            <option v-bind:value="'<>'+entidade.mun_codigo">Fora do Município</option>
          </select>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="ISS Retido" label-for="sep_iss_retido">
          <select id="sep_iss_retido"
                  v-model="filtro.sep_iss_retido"
                  class="custom-select" type="text">
            <option value="">Todos</option>
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </select>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="Situação" label-for="not_cancelada">
          <select id="not_cancelada"
                  v-model="filtro.not_cancelada"
                  class="custom-select" type="text">
            <option value="">Todos</option>
            <option value="1">Normal</option>
            <option value="2">Cancelada</option>
          </select>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <b-form-group
            label="Competência Inicial"
            label-for="sep_competencia_inicial">
          <input
              id="sep_competencia_inicial"
              v-model="filtro.sep_competencia_inicial"
              v-mask="'##/####'"
              type="text"
              maxlength="7"
              class="form-control"
              placeholder="Mês/Ano">
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
            label="Competência Final"
            label-for="sep_competencia_final">
          <input
              id="sep_competencia_final"
              v-model="filtro.sep_competencia_final"
              v-mask="'##/####'"
              type="text"
              maxlength="7"
              class="form-control"
              placeholder="Mês/Ano">
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
            label="Emissão Incial"
            label-for="not_emissao_incial">
          <input
              id="not_emissao_incial"
              v-model="filtro.not_emissao_incial"
              type="date"
              maxlength="10"
              class="form-control"
              placeholder="Dia/Mês/Ano">
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
            label="Emissão Final"
            label-for="not_emissao_final">
          <input
              id="not_emissao_final"
              v-model="filtro.not_emissao_final"
              type="date"
              maxlength="10"
              class="form-control"
              placeholder="Dia/Mês/Ano">
        </b-form-group>
      </div>
    </div>

    <div v-if="tipo ==='DUAM'" class="row">
      <div class="col-md-3">
        <b-form-group
            label="Código da DUAM"
            label-for="dam_codigo">
          <input
              id="dam_codigo"
              v-model="filtro.dam_codigo"
              type="text"
              maxlength="20"
              class="form-control"
              placeholder="">
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="Status" label-for="tab_106situacao">
          <select id="tab_106situacao"
                  v-model="filtro.tab_106situacao"
                  class="custom-select" type="text">
            <option value="">Todas</option>
            <option value="963">Em Aberto</option>
            <option value="964">Aguardando pagamento - sob demanda</option>
            <option value="965">Inscrita Divida Ativa</option>
            <option value="966">Parcelada</option>
            <option value="967">Estorno para Repactuação</option>
            <option value="968">Suspensão Ato Administrativo</option>
            <option value="969">Suspensão Decisão Judicial</option>
            <option value="970">Cancelado</option>
            <option value="971">Prescrita</option>
            <option value="972">Estimativa Simples Nacional</option>
            <option value="973">Isento</option>
            <option value="974">Imune</option>
            <option value="975">Pagamento Parcial</option>
            <option value="976">Pagamento Total</option>
          </select>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
            label="Vencimento Incial"
            label-for="dam_vencimento_inicial">
          <input
              id="dam_vencimento_inicial"
              v-model="filtro.dam_vencimento_inicial"
              type="date"
              maxlength="10"
              class="form-control"
              placeholder="Dia/Mês/Ano">
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
            label="Vencimento Final"
            label-for="dam_vencimento_final">
          <input
              id="dam_vencimento_final"
              v-model="filtro.dam_vencimento_final"
              type="date"
              maxlength="10"
              class="form-control"
              placeholder="Dia/Mês/Ano">
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-form-group>
          <button type="submit"
                  class="btn btn-label btn-primary"><i
              class="bx bx-printer label-icon"></i>
            Gerar Relatório
          </button>
        </b-form-group>
      </div>
    </div>
  </div>
</template>
<script>
import {TheMask} from 'vue-the-mask'
import {notifyAviso} from "@/helps/notificacao";

export default {
  components: {
    TheMask
  },
  props: {
    tipo: {
      type: String
    },
    filtro: {
      type: Object,
      default() {
        return {
          eco_codigo: null,
          not_emissao_ano: "",
          sep_competencia_inicial: "",
          sep_competencia_final: "",
          not_emissao_incial: "",
          not_emissao_final: "",
          sep_exigibilidade_iss: "",
          not_cancelada: "",
          sep_iss_retido: "",
          sep_municipio_incidencia: "",
          sep_cpf_cnpj_tomador: "",
          sep_razao_social_tomador: "",
          tipo_avulsa: "1",
          tab_106situacao: "",
          dam_vencimento_inicial:"",
          dam_vencimento_final:""
        }
      }
    },
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
  },
  created() {
    this.curretEmpresa = this.$store.state.auth.currenEmpresa;
    if (!this.curretEmpresa) {
      notifyAviso("Nenhuma empresa selecionada", "Selecione uma empresa para emitir relatórios")
      this.$router.push({name: 'painel'})
      return;
    }
    this.filtro.eco_codigo = this.curretEmpresa.eco_codigo
  },
};
</script>

